import styled from 'styled-components'

export const InvoicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InvoiceItem = styled.div`
  display: flex;
  flex-direction: column;
  height: 96px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${props => props.theme.size.XXL};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: 0 ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const HeaderGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const DetailLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${props => props.theme.size.L};
  padding: 0 0.75rem;
`

export const DatesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const PaginationContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp24};
  padding-top: ${props => props.theme.spacing.sp24};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
